import React, { useEffect, useMemo, useState } from 'react';
import Helmet from 'react-helmet';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { NumberParam, StringParam, useQueryParam, withDefault } from 'use-query-params';
import { Box, Button, IconButton } from '@material-ui/core';
import { ArrowBack, FilterList } from '@material-ui/icons';
import { AppSnackbar, PageTemplate, PageTemplateCardOver, PageTemplateHeader, PageTemplateHeaderActions, PageTemplateSpinner, SearchBox } from '@sierralabs/core-ui';
import { QueryFilterDrawer, QueryTable } from '@sierralabs/query-ui';
import { useSiteContext } from '../SiteContext';
import ExportReportDialog from './dialogs/ExportReportDialog';
import SaveReportDialog from './dialogs/SaveReportDialog';
import { useGetReport } from './hooks/useGetReport';
const StyledIconButton = styled(IconButton) `
  margin-right: 4px;
`;
export const ReportDetailPage = props => {
    const { queryBuilderPlugins } = props;
    const history = useHistory();
    const { reportId: reportIdParam = '' } = useParams();
    const isNew = reportIdParam === 'new';
    const reportId = parseInt(reportIdParam) || 0;
    const [page, setPage] = useQueryParam('page', withDefault(NumberParam, 0));
    const [limit, setLimit] = useQueryParam('limit', withDefault(NumberParam, 100));
    const [order, setOrder] = useQueryParam('order', withDefault(StringParam, undefined));
    const [directionParam, setDirection] = useQueryParam('direction', withDefault(StringParam, 'ASC'));
    const [search, setSearch] = useQueryParam('search', withDefault(StringParam, ''));
    const [error, setError] = useState();
    const [openDrawer, setOpenDrawer] = useState(isNew);
    const [openSaveDialog, setOpenSaveDialog] = useState(false);
    const [openExportDialog, setOpenExportDialog] = useState(false);
    const [query, setQuery] = useState();
    const { editorPath } = useSiteContext();
    const { report, loadingReport, loadingReportError, getReport } = useGetReport(reportId);
    const direction = directionParam === 'DESC' ? 'DESC' : 'ASC';
    const title = (report === null || report === void 0 ? void 0 : report.query.name) || (isNew ? 'New Report' : 'Report');
    const params = useMemo(() => {
        return { page, limit, order, direction };
    }, [page, limit, order, direction]);
    useEffect(() => {
        !isNew && getReport();
    }, [isNew, getReport]);
    useEffect(() => {
        report && setQuery(report.query);
    }, [report]);
    useEffect(() => {
        setError(loadingReportError);
    }, [loadingReportError]);
    return (React.createElement(PageTemplate, null,
        React.createElement(Helmet, { title: title }),
        React.createElement(PageTemplateHeader, null,
            React.createElement(StyledIconButton, { color: 'inherit', onClick: () => history.push(`${editorPath}reports`) },
                React.createElement(ArrowBack, null)),
            React.createElement("h2", null, title),
            React.createElement(SearchBox, { value: search, onSearch: value => setSearch(value) },
                React.createElement(Box, { ml: 1 },
                    React.createElement(IconButton, { color: 'inherit', onClick: () => setOpenDrawer(true) },
                        React.createElement(FilterList, null))),
                React.createElement(QueryFilterDrawer, { open: openDrawer, query: report === null || report === void 0 ? void 0 : report.query, plugins: queryBuilderPlugins, defaultHideAdvanced: false, onClose: () => setOpenDrawer(false), onQueryChange: query => {
                        setOpenDrawer(false);
                        setQuery(Object.assign({}, query));
                    }, action: React.createElement(React.Fragment, null,
                        React.createElement(Box, { mt: 2 },
                            React.createElement(Button, { fullWidth: true, color: 'primary', variant: 'outlined', onClick: () => setOpenSaveDialog(true) },
                                report ? 'Save' : 'Save as',
                                " Report")),
                        openSaveDialog && (React.createElement(SaveReportDialog, { open: true, report: report, queryConfig: query === null || query === void 0 ? void 0 : query.config, onCancel: () => setOpenSaveDialog(false), onSave: report => {
                                setOpenSaveDialog(false);
                                history.push(`${editorPath}reports/${report.id}`);
                            } }))) })),
            React.createElement(PageTemplateHeaderActions, null,
                React.createElement(Button, { color: 'primary', variant: 'contained', onClick: () => setOpenExportDialog(true) }, "Export"))),
        React.createElement(PageTemplateCardOver, null,
            loadingReport && React.createElement(PageTemplateSpinner, null),
            query && (React.createElement(QueryTable, { query: query, params: params, onChange: params => {
                    setPage(params.page);
                    setLimit(params.limit);
                    setOrder(params.order);
                    setDirection(params.direction);
                } }))),
        React.createElement(AppSnackbar, { severity: 'error', open: !!error, onClose: () => setError(undefined) }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.'),
        query && (React.createElement(ExportReportDialog, { query: query, report: report, open: openExportDialog, onCancel: () => setOpenExportDialog(false) }))));
};
export default ReportDetailPage;
//# sourceMappingURL=ReportDetailPage.js.map